module.exports = __webpack_public_path__ + "img/icona_div_italia.1372939a.png";